<template>
    <div>
        <a-drawer title="" width="550" placement="right" @close="onClose" :visible="drawerVisible">

            <div v-if="formType == 'g'">
                <h6 class="heading-small text-muted mb-4" v-if="formMode == 'a'">Add Combo Group</h6>
                <h6 class="heading-small text-muted mb-4" v-else-if="formMode == 'v'">View Combo Group - {{
                    this.comboGroupName }}</h6>
                <h6 class="heading-small text-muted mb-4" v-else>Edit Combo Group - {{ this.comboGroupName }}</h6>
                <base-alert v-if="errors.length" type="danger">
                    <b>You have the following error(s):</b>
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                </base-alert>
                <!-- <base-input label="Group Type" required>
                        <a-select v-model="comboGroup.group_type" showSearch placeholder="Select Group Type"
                            optionFilterProp="children" style="width: 100%" :filterOption="true">
                            <a-select-option v-for="option in grptype" :key="option.id" :value="option.id">
                                {{ option.name }}
                            </a-select-option>
                        </a-select>
                    </base-input> -->

                <!-- Combo Group  -->

                <base-input label="Name" required>
                    <a-input type="text" v-model="comboGroup.name" input-classes="form-control" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Reference Code">
                    <a-input type="string" v-model="comboGroup.reference_code" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Card Type">
                    <a-select
                        showSearch
                        v-model="comboGroup.card_type_id"
                        style="width: 100%"
                        placeholder="Please select"
                        :filterOption="false"
                        :notFoundContent="fetchingCardTypes ? undefined : null"
                        :disabled="hideSave == 1"
                        @search="fetchSupercardTypes"
                        @focus="fetchSupercardTypes()"
                    >
                        <a-spin v-if="fetchingCardTypes" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in supercardTypes" :key="option.id" :value="option.id">{{ option.name }}</a-select-option>
                    </a-select>
                </base-input>
                <base-input label="Combo Value Link">
                    <small class="d-block mt--1 mb-2">Enable the combo group only when this combo value is selected.</small>
                    <a-select mode="multiple" v-model="comboGroup.combo_value_link" style="width: 100%"
                        @change="comboGroup.combo_value_link.sort((a, b) => a - b)" :disabled="hideSave == 1">
                        <a-select-option v-for="value in comboValueChoices" :key="value.id">
                            {{ value.name }}
                        </a-select-option>
                    </a-select>
                </base-input>
                <base-input label="Sequence No" required class="w-100">
                    <a-input type="number" v-model="comboGroup.sequence_no" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Option Type" required class="d-flex justify-content-between align-items-center">
                    <a-radio-group v-model="comboGroup.option_type" button-style="solid" :disabled="hideSave == 1">
                        <a-radio-button value="single">Single Product</a-radio-button>
                        <a-radio-button value="multiple">Multiple</a-radio-button>
                        <a-radio-button value="option">Option</a-radio-button>
                    </a-radio-group>
                </base-input>
                <base-input type="number" min="0" label="Minimum Quantity" v-model="comboGroup.min_qty" required :disabled="disableIfSingleType"/>
                <base-input type="number" min="0" label="Maximum Quantity" v-model="comboGroup.max_qty" required :disabled="disableIfSingleType"/>  
                <base-input label="Status" required class="d-flex justify-content-between align-items-center">
                    <a-radio-group v-model="comboGroup.status" button-style="solid" :disabled="hideSave == 1">
                        <a-radio-button value="A" defaultChecked>Active</a-radio-button>
                        <a-radio-button value="I">Inactive</a-radio-button>
                    </a-radio-group>
                </base-input>
                <base-input label="Required" required class="d-flex justify-content-between align-items-center">
                    <a-switch v-model="comboGroup.is_required" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Freebie" required class="d-flex justify-content-between align-items-center">
                    <a-switch v-model="comboGroup.is_freebie" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Main Combo Group" required class="d-flex justify-content-between align-items-center">
                    <a-switch v-model="comboGroup.is_main_option" :disabled="hideSave == 1" />
                </base-input>

                <!-- End Combo Group  -->

                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-success" @click.prevent="saveGroup" v-if="hideSave == 0">Save</button>
                    <button class="btn" @click.prevent="onClose">Cancel</button>
                </div>
            </div>

            <div v-if="formType == 'v'">
                <h6 class="heading-small text-muted mb-4" v-if="formMode == 'a'">Add Combo Value</h6>
                <h6 class="heading-small text-muted mb-4" v-else-if="formMode == 'v'">View Combo Value - {{
                    this.comboValueName }}</h6>
                <h6 class="heading-small text-muted mb-4" v-else>Edit Combo Value - {{ this.comboValueName }}</h6>
                <!-- <div v-if="comboGroup.group_type == 1"> -->
                <base-input label="Name" required>
                    <a-input type="text" v-model="comboValue.name" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Description">
                    <textarea rows="4" class="form-control" v-model="comboValue.description" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Reference Code">
                    <a-input type="text" v-model="comboValue.reference_code" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Price" required>
                    <a-input type="number" v-model="comboValue.price" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Minimum Quantity" required>
                    <a-input type="number" v-model="comboValue.min_qty" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Maximum Quantity" required>
                    <a-input type="number" v-model="comboValue.max_qty" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Sequence No." required>
                    <a-input type="number" v-model="comboValue.sequence_no" :disabled="hideSave == 1" />
                </base-input>
                <base-input label="Status" required class="d-flex justify-content-between align-items-center">
                    <a-radio-group v-model="comboValue.status" button-style="solid" :disabled="hideSave == 1">
                        <a-radio-button value="A" defaultChecked>Active</a-radio-button>
                        <a-radio-button value="I">Inactive</a-radio-button>
                    </a-radio-group>
                </base-input>

                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-success" @click.prevent="saveValue" v-if="hideSave == 0">Save</button>
                    <button class="btn" @click.prevent="onClose">Close</button>
                </div>
                <!-- </div> -->
                <!-- <div v-if="comboGroup.group_type == 2">
                        <base-input label="Name">
                            <a-input type="text" v-model="comboValue.name" disabled />
                        </base-input>
                        <base-input label="Price">
                            <a-input type="number" value="0.00" disabled />
                        </base-input>
                        <base-input label="Minimum Quantity">
                            <a-input type="number" value="0" disabled />
                        </base-input>
                        <base-input label="Maximum Quantity">
                            <a-input type="number" value="1" disabled />
                        </base-input>
                        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                            <button class="btn btn-success" @click.preValue="">Save</button>
                            <button class="btn" @click.prevent="onClose">Close</button>
                        </div>
                    </div> -->
            </div>
            <!-- <div v-if="formType == 'v'">
                    <h6 class="heading-small text-muted mb-4">Product Variants</h6>
                    <base-input label="Variant Selection" class="col-md-12">
                        <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"
                            v-model="comboVariant.id">
                            <a-select-option v-for="v in variantSelection" :key="v.id" :value="v.id">{{ v.name
                            }}</a-select-option>
                        </a-select>
                    </base-input>
                    <base-input label="Name">
                        <a-input type="text" v-model="comboVariant.name" />
                    </base-input>
                    <base-input label="Additional Price">
                        <a-input type="number" v-model="comboVariant.additionalPrice" />
                    </base-input>
                    <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                        <button class="btn btn-success" @click.prevent="saveVariant">Save</button>
                        <button class="btn" @click.prevent="onClose">Cancel</button>
                    </div>
                </div> -->
        </a-drawer>

        <h3>Meal Definition</h3>
        <!-- {{comboGroups}} -->
        <div class="row align-items-start" style="max-height: 600px">

            <!-- GROUPS -->
            <div class="col-md-6 col-sm-6" style="padding:0px; border-right: 1px #E9ECEF solid;">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                        <div class="row">
                            <div class="col-md-8">COMBO GROUPS</div>
                            <div class="col-md-4 float-right">
                                <base-button class="float-right ml-1" type="primary" :disabled="btnValues == 1" size="sm"
                                    @click.prevent="showComboDrawer('g', 'a')"><span class="fa fa-plus" />
                                </base-button>
                            </div>
                        </div>
                    </li>
                    <div style="height: 330px; overflow-y: auto;">
                        <!-- <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock"/> &nbsp; Sample</li> -->
                        <li class="list-group-item" style="font-size: 14px; height: 55px" v-for="group in comboGroups"
                            :key="group.name" :class="[{ selected2: comboGroupName == group.name }]">
                            <div class="row align-items-center" @click="selectGroup(group)">
                                <div class="col-md-8">
                                    <a-dropdown v-if="comboGroupName == group.name">
                                        <a class="ant-dropdown-link" href="#">
                                            <span class="fa fa-ellipsis-v"></span>
                                        </a>
                                        <a-menu slot="overlay">
                                            <a-menu-item @click="showComboDrawer('g', 'v')">
                                                View {{ group.name }}
                                            </a-menu-item>
                                            <a-menu-item @click="showComboDrawer('g', 'e')">
                                                Edit {{ group.name }}
                                            </a-menu-item>
                                            <a-menu-item key=2 :disabled="btnValues == 1">
                                                <a-popconfirm :disabled="btnValues == 1"
                                                    okText="Delete"
                                                    cancelText="Cancel" @confirm="deleteGroup(group.id)">
                                                    <template #title>
                                                        <div>
                                                            You are about to delete this record?<br />
                                                            Deleting this will also delete the product combo values and product combo prices related under this product combo group.
                                                        </div>
                                                    </template>
                                                    Delete {{ group.name }}
                                                </a-popconfirm>
                                            </a-menu-item>
                                        </a-menu>
                                    </a-dropdown> &nbsp;
                                    {{ group.name }} <!--| {{group.group_type_name}}-->
                                </div>
                                <div class="col-md-4">
                                    <span class="ni ni-bold-right float-right" />
                                </div>
                            </div>
                        </li>
                    </div>
                </ul>
            </div>

            <!-- PRODUCTS -->
            <div class="col-md-6 col-sm-6" style="padding:0px; border-right: 1px #E9ECEF solid;">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                        <div class="row">
                            <div class="col-md-8">COMBO VALUES</div>
                            <div class="col-md-4 float-right">
                                <base-button :disabled="comboGroupName == null" class="float-right ml-1" type="primary"
                                    size="sm" @click.prevent="showComboDrawer('v', 'a')"><span class="fa fa-plus" />
                                </base-button>
                            </div>
                            <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                        </div>
                    </li>
                </ul>
                <div style="height: 330px; overflow-y: auto;">
                    <!-- <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock"/> &nbsp; Sample</li> -->
                    <li class="list-group-item" style="font-size: 14px; height: 55px" v-for="value in comboValues"
                        :key="value.id" :class="[{ selected2: comboValueId == value.id }]" @click="selectValue(value)">
                        <div class="row">
                            <div class="col-md-8">
                                <a-dropdown v-if="comboValueId == value.id">
                                    <a class="ant-dropdown-link" href="#">
                                        <span class="fa fa-ellipsis-v"></span>
                                    </a>
                                    <a-menu slot="overlay">
                                        <a-menu-item @click="showComboDrawer('v', 'v')"> View {{ value.name }}
                                        </a-menu-item> <a-menu-item @click="showComboDrawer('v', 'e')"> Edit {{ value.name
                                        }}
                                        </a-menu-item>
                                        <a-menu-item key=2 :disabled="btnValues == 1">
                                            <a-popconfirm :disabled="btnValues == 1"
                                                okText="Delete"
                                                cancelText="Cancel" @confirm="deleteValue(value.id)">
                                                <template #title>
                                                        <div>
                                                            You are about to delete this record?<br />
                                                            Deleting this will also delete the product combo prices related under this product combo value.
                                                        </div>
                                                    </template>
                                                Delete {{ value.name }}
                                            </a-popconfirm>
                                        </a-menu-item>
                                    </a-menu>
                                </a-dropdown> &nbsp;
                                {{ value.name }}
                            </div>
                            <!-- <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div> -->
                        </div>
                    </li>
                </div>
            </div>

            <!-- VARIANTS -->
            <!-- <div class="col-md-4 col-sm-4" style="padding:0px; height: 300px; display: none;">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                            <div class="row">
                                <div class="col-md-8">VARIANTS</div>
                                <div class="col-md-4 float-right">
                                    <base-button :disabled="comboValue.product_type != 'M'" class="float-right ml-1"
                                        type="primary" size="sm" @click.prevent="showComboDrawer('v', 'a')"><span
                                            class="fa fa-plus" /> </base-button>
                                    <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('t', 'a')"><span class="fa fa-plus"/> </base-button>
                                </div>
                                <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div>
                            </div>
                        </li>
                        <div v-if="comboValue.product_type == 'M'" style="height: 545px; overflow-y: auto;">
                            <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock"/> &nbsp; Sample</li>
                            <li class="list-group-item" style="font-size: 14px" v-for="variant in comboVariants"
                                :key="variant.id" :class="[{ selected2: comboVariantId == variant.id }]">
                                <div class="row" @click="selectVariant(variant)">
                                    <div class="col-md-12">
                                        <a-dropdown v-if="comboVariantId == variant.id">
                                            <a class="ant-dropdown-link" href="#">
                                                <span class="fa fa-ellipsis-v"></span>
                                            </a>
                                            <a-menu slot="overlay">
                                                <a-menu-item @click="showComboDrawer('v', 'e')"> Edit - {{ variant.name }}
                                                </a-menu-item>
                                                <a-menu-item key=2>
                                                    <a-popconfirm title="You are about to delete this record?"
                                                        okText="Delete" cancelText="Cancel" @confirm="deleteVariant()">
                                                        Delete - {{ variant.name }}
                                                    </a-popconfirm>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown> &nbsp;
                                        {{ variant.name }}
                                    </div>
                                    <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                </div>
                            </li>
                        </div>
                        <div v-else style="height: 545px; overflow-y: auto;">
                            <a-empty class='mt-5' :image-style="{ height: '50px', }">
                                <span slot="description"> No variant available for the selected product. </span>
                            </a-empty>
                        </div>
                    </ul>
                </div> -->
        </div>
    </div>
</template>

<script>

import { mapState, /*mapActions*/ } from 'vuex'
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'

export default {
    data: function () {
        return {
            drawerVisible: false,
            formType: "g",
            formMode: "a",
            hideSave: 0,
            disableIfSingleType: false,

            comboGroups: [],
            comboGroup: {
                id: null,
                name: null,
                reference_code: '',
                product_id: this.profileId,
                combo_value_link: null,
                combo_value_link_arr: [],
                sequence_no: 0,
                option_type: null,
                min_qty: 0,
                max_qty: 1,
                status: 'A',
                is_required: false,
                is_freebie: false,
                is_main_option: false,
                card_type_id: null
            },
            comboGroupName: null,

            // optionGroups: [],
            // optionGroup: {},
            // optionGroupName: null,

            barcodeSearch: null,
            comboValues: [],
            comboValue: {
                id: null,
                name: null,
                min_qty: 0,
                max_qty: 1,
                price: 0.0,
                product_combo_group_id: null,
                status: 'A',
                sequence_no: 0,
                product_id: null,
                reference_code: null,
                description: null,
                img_url: null
            },
            comboValueId: null,
            comboValueName: null,

            comboVariants: [],
            comboVariant: {},
            comboVariantId: null,
            variantSelection: [],

            prodcmbgrp: [],
            prodoptgrp: [],
            optgrp: [],
            cmbgrp: [],
            errors: [],
            grptype: [
                {
                    id: 1,
                    name: 'Combo Group'
                },
                {
                    id: 2,
                    name: 'Option Group'
                }
            ],
            prodComboDetails: {
                combo_group_id: [],
                option_group_id: []
            },
            comboValueChoices: [],
            comboValueCascade: [],
            supercardTypes: [],
            fetchingCardTypes: false
        }
    },
    props: ['prodData', 'prodDataDetails', 'btnValues', 'comboDefFetch'],
    computed: {
        ...mapState(['endPoint', 'publicUrl', 'categoriesOptions', 'profileId']),
        option_type() {
            return this.comboGroup.option_type
        }
    },
     watch: {
        option_type: function () {
            if(this.comboGroup.option_type == 'single'){ 
                this.disableIfSingleType = true
                this.comboGroup.min_qty = 1
                this.comboGroup.max_qty = 1
            } else { 
                this.disableIfSingleType = false
            }
        }
    },
    mounted: async function () {
        await this.fetchSupercardTypes()
        const ComboGroups = await HTTPRequest.getRequest(this.endPoint + `product_combo_groups?product_id=${this.profileId}`, null)
        this.prodcmbgrp = ComboGroups.data

        if (this.prodData != null && (this.prodData['combo_group_id'].length > 0 || this.prodData['option_group_id'].length > 0)) {
            this.prodComboDetails = this.prodData
            this.cmbgrp = this.prodData['combo_group_id']
        }

        if ((this.comboDefFetch.combo_group_id.length > 0 || this.comboDefFetch.option_group_id.length > 0) && this.comboGroups.length === 0) {
            this.prodComboDetails = this.comboDefFetch
            this.cmbgrp = this.comboDefFetch['combo_group_id']
            // this.optgrp = this.comboDefFetch['option_group_id']

            //if with combo id
            //populate combo details and items
            if (this.comboDefFetch.combo_group_id.length > 0) {
                for (const comboid of this.comboDefFetch.combo_group_id) {
                    this.pushMealDefinition(comboid);
                }
            }
        }
    },
    methods: {
        async fetchSupercardTypes(searchValue = '') {
            this.fetchingCardTypes = true
            let response = await HTTPRequest.getRequest(this.endPoint + `supercard_types?name=${encodeURIComponent(searchValue)}&per_page=50`, null)
            this.fetchingCardTypes = false

            if (response && response.data != undefined) {
                this.supercardTypes = response.data
            } else if (response && response.error == undefined && Array.isArray(response)) {
                this.supercardTypes = response
            }
        },
        async pushMealDefinition (typeId) {
            this.comboGroup = {}

            this.comboGroup = this.prodcmbgrp.find(group => typeId == group.id)
            if (Number.isInteger(this.comboGroup.combo_value_link)) {
                this.comboGroup.combo_value_link = [this.comboGroup.combo_value_link]
            } else if (this.comboGroup.combo_value_link == null) {
                this.comboGroup.combo_value_link = []
            }

            this.comboGroups.push(this.comboGroup)
            this.comboGroup = {}

        },
        async showComboDrawer (type, mode) {
            this.formType = type
            this.formMode = mode
            this.drawerVisible = true
            this.errors = []

            if (this.formMode == 'v')
                this.hideSave = 1
            else
                this.hideSave = 0

            if (this.formType == 'g') {
                let comboValues = await HTTPRequest.getRequest(`${this.endPoint}product_combo_values?product_id=${this.profileId}`, null, null)
                this.comboValueChoices = comboValues.data.filter(val => val.product_combo_group_id != this.comboGroup.id)

                if (this.formMode == 'a') {
                    this.comboGroup = {
                        name: null,
                        reference_code: '',
                        product_id: this.profileId,
                        combo_value_link: [],
                        sequence_no: 0,
                        option_type: null,
                        min_qty: 0,
                        max_qty: 1,
                        status: 'A',
                        is_required: false,
                        is_freebie: false,
                        is_main_option: false,
                        card_type_id: null
                    }

                    this.comboValues = []
                    this.comboValue = {}
                }
            }

            if (this.formType == 'v' && this.formMode == 'a') {
                this.comboValue = {
                    name: null,
                    min_qty: 0,
                    max_qty: 1,
                    price: 0,
                    product_combo_group_id: this.comboGroup.id,
                    status: 'A',
                    sequence_no: 0,
                    product_id: null,
                    reference_code: null,
                    description: null,
                    img_url: null
                }
            }
        },
        onClose () {
            this.drawerVisible = false
        },
        async selectGroup (group) {
            this.comboGroup = Object.assign({}, group)
            let fetch_flag = true, fetch_page = 1
            while (fetch_flag) {
                // let comboValues = await HTTPRequest.getRequest(this.endPoint + 'product_combo_values?product_combo_group_id=' + this.comboGroup.id, null)
                let comboValues = await HTTPRequest.getRequest(`${this.endPoint}product_combo_values?product_combo_group_id=${this.comboGroup.id}&per_page=500&page=${fetch_page}`, null, null)
                this.comboValues = comboValues.data
                if ((fetch_page == comboValues.last_page) || (comboValues.last_page == 0))
                    fetch_flag = false
                else
                    fetch_page++
            }
            this.comboGroupName = group.name
            this.comboValue = {}

        },
        async saveGroup () {
            this.errors = []
            this.errors.push(ValidateField.required("Name", this.comboGroup.name))
            this.errors.push(ValidateField.alphanumericWithSpecialChars("Name", this.comboGroup.name))
            this.errors.push(ValidateField.alphanumericWithSpecialChars("Reference Code", this.comboGroup.reference_code))
            this.errors.push(ValidateField.isWholeNumber("Sequence No", this.comboGroup.sequence_no))
            this.errors.push(ValidateField.required("Option Type", this.comboGroup.option_type))
            this.errors.push(ValidateField.isWholeNumber("Minimum Quantity", this.comboGroup.min_qty))
            this.errors.push(ValidateField.isWholeNumber("Maximum Quantity", this.comboGroup.max_qty))
            this.errors.push(ValidateField.required("Status", this.comboGroup.status))
            this.errors = this._.compact(this.errors);

            if (!this.errors.length) {
                if (this.formMode == 'a') {
                    // if(!this.validateForm()) {
                    this.comboGroup.name = this.comboGroup.name.trim()
                    let groupPayload = { product_combo_groups: this.comboGroup }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'product_combo_groups', null, groupPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.comboGroup.id = post_request.id
                            this.prodComboDetails.combo_group_id.push(post_request.id)
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                    // }
                    if (this.errors.length > 0)
                        return false
                    this.comboGroups.push(this.comboGroup)

                } else {
                    // if(!this.validateForm()) {
                    this.comboGroup.name = this.comboGroup.name.trim()
                    let groupPayload = { product_combo_groups: this.comboGroup }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_combo_groups/' + this.comboGroup.id, null, groupPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                    // }

                    //Find index of specific object using findIndex method.    
                    let objIndex = this.comboGroups.findIndex((obj => obj.id == this.comboGroup.id));
                    this.comboGroups[objIndex] = this.comboGroup
                    this.comboGroupName = this.comboGroup.name
                }

                //Pass Data to parent(ProductForm)
                this.$emit('saveGroupDetails', this.comboGroups)

                //Pass Data to parent(ProductForm)
                this.$emit('saveGroup', this.prodComboDetails)

                this.cmbgrp = this.prodComboDetails.combo_group_id
                this.drawerVisible = false

            } else return false

        },
        async deleteGroup (id) {

            var destroy_request = await HTTPRequest.destroyRequest(this.endPoint + 'product_combo_groups/' + id, null, null)
            if (destroy_request == undefined) {
                this.$emit('refreshPage', event)
            } else {
                if (destroy_request["error"] == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    this.errors = destroy_request["error"].split(",")
                }
            }

            let objIndex = this.comboGroups.findIndex((obj => obj.id == id));
            this.comboGroups.splice(objIndex, 1)
            this.comboGroup = {}


            //Pass Data to parent(ProductForm)
            this.$emit('saveGroupDetails', this.comboGroups)

            const groupArray = this.prodComboDetails.combo_group_id
            const index = groupArray.indexOf(id);
            if (index > -1)
                groupArray.splice(index, 1);

            //Pass Data to parent(ProductForm)
            this.$emit('saveGroup', this.prodComboDetails)
            this.cmbgrp = this.prodComboDetails.combo_group_id

        },
        async saveValue () {
            if (this.formMode == "a") {
                this.comboValue.name = this.comboValue.name.trim()
                this.comboValue.product_id = this.comboGroup.product_id
                let valuePayload = { product_combo_values: this.comboValue }

                var post_request = await HTTPRequest.postRequest(this.endPoint + 'product_combo_values', null, valuePayload)
                if (post_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (post_request["error"] == undefined) {
                        this.comboValue.id = post_request.id
                        this.$emit('refreshPage', event)
                        this.drawerVisible = false
                        this.comboValues.push(this.comboValue)
                    } else {
                        this.errors = post_request["error"].split(",")
                    }
                }

                // this.comboValues.push(this.comboValue)

            } else {
                this.comboValue.name = this.comboValue.name.trim()
                this.comboValue.product_id = this.comboGroup.product_id
                let valuePayload = { product_combo_values: this.comboValue }

                var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_combo_values/' + this.comboValueId, null, valuePayload)
                if (put_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",")
                    }
                }

                let objIndex = this.comboValues.findIndex((obj => obj.id == this.comboValueId));
                this.comboValues[objIndex] = this.comboValue
                this.comboValueName = this.comboValue.name
            }

            this.drawerVisible = false
        },
        async deleteValue (id) {
            var destroy_request = await HTTPRequest.destroyRequest(this.endPoint + 'product_combo_values/' + id, null, null)
            if (destroy_request == undefined) {
                this.$emit('refreshPage', event)
            } else {
                if (destroy_request["error"] == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    this.errors = destroy_request["error"].split(",")
                }
            }

            let objIndex = this.comboValues.findIndex((obj => obj.id == id));
            this.comboValues.splice(objIndex, 1)
            this.comboValue = {}
        },
        async selectValue (value) {
            this.comboValue = Object.assign({}, value)
            this.comboValueId = value.id
            this.comboValueName = value.name
        },
    }
}
</script>
